const mutations = {
    loadExperiments: function(state, data) {
        if (data.channel) state.experiments.channel = data.channel;
        if (data.date) state.experiments.date = data.date;
        if (data.overrideChannel) state.experiments.overrideChannel = data.overrideChannel;
    }
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/ABTest/mutations.js